<ng-template>
  <div
    role="tabpanel"
    class="tw-px-4 tw-py-5"
    [attr.tabIndex]="noFocusableChildren ? 0 : undefined"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
